import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { SwiperOptions } from "swiper/types/swiper-options";

// Docs: https://v9.swiperjs.com/get-started
import "swiper/css";
import "./ch_swiper.scss";

export function renderChSwiper(container: string | HTMLElement, options: SwiperOptions) {
  const swiper = new Swiper(container, {
    ...options,
    modules: [Navigation, Pagination]
  });

  return swiper;
}